import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface Props {
    label: string;
    value: Date | null;
    onChange: (date: Date | null) => void;
    format?: string;
    helperText?: string | null;
}

export const CustomDatePicker = ({ label, value, onChange, format, helperText }: Props) => {
    return (
        <KeyboardDatePicker
            disableToolbar
            autoOk
            fullWidth
            variant="inline"
            format={format || 'dd.MM.yyyy'}
            label={label}
            value={value}
            inputVariant="outlined"
            onChange={onChange}
            helperText={helperText}
            error={!!helperText}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            style={{ marginRight: '24px' }}
        />
    );
};

export default CustomDatePicker;
